"use strict";

import _ from "lodash";
import angular from "angular";
import SlimSelect from "slim-select";
import supportsTime from "time-input-polyfill/supportsTime";
import TimePolyfill from "time-input-polyfill";
import moment from "moment";
import phone from "phone";

import newDateInputTemplate from "./new_date_input.html";
import phoneNumberInputTemplate from "./phone_number_input.html";
import cfVideoTemplate from "./cf_video.html";
import otpInputTemplate from "./otp_input.html";
import textInputTemplate from "./text_input.html";
import currencyInputTemplate from "./currency_input.html";
import textAreaTemplate from "./textarea_input.html";
import radioInputTemplate from "./radio_input.html";
import cardHeaderTemplate from "./card_header.html";
import actionCardTemplate from "./action_card.html";
import passwordInputTemplate from "./password_input.html";
import formTripleActionTemplate from "./form_triple_action.html";
import spinnerTemplate from "./spinner.html";
import profilePictureTemplate from "./profile_picture.html";
import multiSelectDropdownTemplate from "./multi_select_dropdown.html";
import { marked } from "marked";
import uiLinkTemplate from "./ui_link.html";
import anchorButtonTemplate from "./anchor_button.html";
import warning from "@material-design-icons/svg/outlined/warning.svg";
import arrow_forward from "@material-design-icons/svg/outlined/arrow_forward.svg";
import update from "@material-design-icons/svg/outlined/update.svg";
import check_circle from "@material-design-icons/svg/outlined/check_circle.svg";
import timelapse from "@material-design-icons/svg/outlined/timelapse.svg";
import thumb_up from "@material-design-icons/svg/outlined/thumb_up.svg";
import close from "@material-design-icons/svg/outlined/close.svg";
import done from "@material-design-icons/svg/outlined/done.svg";
import home from "@material-design-icons/svg/outlined/home.svg";
import help from "@material-design-icons/svg/outlined/help.svg";
import settings from "@material-design-icons/svg/outlined/settings.svg";
import menu from "@material-design-icons/svg/outlined/menu.svg";
import arrow_drop_down from "@material-design-icons/svg/outlined/arrow_drop_down.svg";
import add from "@material-design-icons/svg/outlined/add.svg";
import file_download from "@material-design-icons/svg/outlined/file_download.svg";
import fiber_manual_record from "@material-design-icons/svg/outlined/fiber_manual_record.svg";
import place from "@material-design-icons/svg/outlined/place.svg";
import highlight_off from "@material-design-icons/svg/outlined/highlight_off.svg";
import print from "@material-design-icons/svg/outlined/print.svg";
import autorenew from "@material-design-icons/svg/outlined/autorenew.svg";
import clear_all from "@material-design-icons/svg/outlined/clear_all.svg";
import attach_file from "@material-design-icons/svg/outlined/attach_file.svg";
import add_location from "@material-design-icons/svg/outlined/add_location.svg";
import play_circle_outline from "@material-design-icons/svg/outlined/play_circle_outline.svg";
import description from "@material-design-icons/svg/outlined/description.svg";
import person from "@material-design-icons/svg/outlined/person.svg";
import volume_up from "@material-design-icons/svg/outlined/volume_up.svg";
import arrow_back from "@material-design-icons/svg/outlined/arrow_back.svg";
import schedule from "@material-design-icons/svg/outlined/schedule.svg";
import delete_icon from "@material-design-icons/svg/outlined/delete.svg";
import import_export from "@material-design-icons/svg/outlined/import_export.svg";
import expand_more from "@material-design-icons/svg/outlined/expand_more.svg";
import expand_less from "@material-design-icons/svg/outlined/expand_less.svg";
import remove_circle_outline from "@material-design-icons/svg/outlined/remove_circle_outline.svg";
import class_icon from "@material-design-icons/svg/outlined/class.svg";
import send from "@material-design-icons/svg/outlined/send.svg";
import phone_enabled from "@material-design-icons/svg/outlined/phone_enabled.svg";
import send_to_mobile from "@material-design-icons/svg/outlined/send_to_mobile.svg";
import phone_disabled from "@material-design-icons/svg/outlined/phone_disabled.svg";
import arrow_right_alt from "@material-design-icons/svg/outlined/arrow_right_alt.svg";
import link from "@material-design-icons/svg/outlined/link.svg";
import open_in_browser from "@material-design-icons/svg/outlined/open_in_browser.svg";
import open_in_new from "@material-design-icons/svg/outlined/open_in_new.svg";
import check from "@material-design-icons/svg/outlined/check.svg";
import cancel from "@material-design-icons/svg/outlined/cancel.svg";
import sort from "@material-design-icons/svg/outlined/sort.svg";
import filter_list from "@material-design-icons/svg/outlined/filter_list.svg";
import cancel_presentation from "@material-design-icons/svg/outlined/cancel_presentation.svg";
import assignment from "@material-design-icons/svg/outlined/assignment.svg";
import notifications_active from "@material-design-icons/svg/outlined/notifications_active.svg";
import person_add from "@material-design-icons/svg/outlined/person_add.svg";
import create from "@material-design-icons/svg/outlined/create.svg";
import pan_tool from "@material-design-icons/svg/outlined/pan_tool.svg";
import done_all from "@material-design-icons/svg/outlined/done_all.svg";
import timer from "@material-design-icons/svg/outlined/timer.svg";
import call from "@material-design-icons/svg/outlined/call.svg";
import directions from "@material-design-icons/svg/outlined/directions.svg";
import email from "@material-design-icons/svg/outlined/email.svg";
import directions_car from "@material-design-icons/svg/outlined/directions_car.svg";
import health_and_safety from "@material-design-icons/svg/outlined/health_and_safety.svg";
import call_made from "@material-design-icons/svg/outlined/call_made.svg";
import navigate_next from "@material-design-icons/svg/outlined/navigate_next.svg";
import badge from "@material-design-icons/svg/outlined/badge.svg";
import upload from "@material-design-icons/svg/outlined/upload.svg";
import swap_horiz from "@material-design-icons/svg/outlined/swap_horiz.svg";
import bolt from "@material-design-icons/svg/outlined/bolt.svg";
import preview from "@material-design-icons/svg/outlined/preview.svg";
import library_books from "@material-design-icons/svg/outlined/library_books.svg";
import star from "@material-design-icons/svg/outlined/star.svg";
import currency_exchange from "@material-design-icons/svg/outlined/currency_exchange.svg";
import archive from "@material-design-icons/svg/outlined/archive.svg";
import chat from "@material-design-icons/svg/outlined/chat.svg";
import mic from "@material-design-icons/svg/outlined/mic.svg";
import stop from "@material-design-icons/svg/outlined/stop.svg";
import report from "@material-design-icons/svg/outlined/report.svg";
import photo_camera from "@material-design-icons/svg/outlined/photo_camera.svg";
import account_balance from "@material-design-icons/svg/outlined/account_balance.svg";
import credit_card from "@material-design-icons/svg/outlined/credit_card.svg";
import history from "@material-design-icons/svg/outlined/history.svg";
import whatshot from "@material-design-icons/svg/outlined/whatshot.svg";
import search from "@material-design-icons/svg/outlined/search.svg";
import { ENGLISH } from "../../app.constants";
import stateProgressBarTemplate from "./state_progress_bar.html";
import mixpanel from "mixpanel-browser";
import { DATE_FORMAT, COMMON_DATE_FORMAT } from "./common.constants";

/* @ngInject */
export function timePicker() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModelCtrl) {
            if (!supportsTime) {
                let $input = element[0];
                new TimePolyfill($input);
                if ($input.polyfill) {
                    //format text going to user (model to view)
                    ngModelCtrl.$formatters.push(function (value) {
                        return moment(value).format("hh:mm A");
                    });

                    //format text from the user (view to model)
                    ngModelCtrl.$parsers.push(function (value) {
                        return moment($input.dataset.value, "H:m A").toDate();
                    });
                }
            }
        },
    };
}

/* @ngInject */
export function slimSelect($timeout) {
    return {
        require: "ngModel",
        scope: {
            ngDisabled: "=ngDisabled",
            keepOrder: "=",
            ngModel: "=",
        },
        link: function (scope, element, attr, ngModelCtrl) {
            $timeout(function () {
                let rawElement = element[0];
                let opts = {
                    select: rawElement,
                    placeholder: false,
                    settings: {},
                    events: {
                        afterChange: (newVal) => {
                            updateModel(newVal);
                        },
                    },
                };
                opts.settings.keepOrder = _.get(scope, "keepOrder", false);
                let select = new SlimSelect(opts);

                let previousValue = [];

                function updateModel(newVal) {
                    if (opts.settings.keepOrder) {
                        let addedElements = _.differenceBy(
                            scope.ngModel,
                            previousValue,
                            "value",
                        );
                        let removedElements = _.differenceBy(
                            previousValue,
                            scope.ngModel,
                            "value",
                        );

                        let currentElements = _.pullAllBy(
                            previousValue,
                            removedElements,
                            "value",
                        );
                        currentElements = _.concat(
                            currentElements,
                            addedElements,
                        );

                        ngModelCtrl.$setViewValue(currentElements);

                        previousValue = currentElements;
                    }
                }

                scope.$watch("ngDisabled", function (value) {
                    if (scope.ngDisabled) {
                        select.disable();
                    } else {
                        select.enable();
                    }
                });
            });
        },
    };
}

/* @ngInject */
export function backButton() {
    return {
        restrict: "E",
        transclude: true,
        scope: {
            sref: "@sref",
        },
        template:
            '<a class="flex item-center" ui-sref="{{sref || \'^\'}}">' +
            '<material-icon name="arrow_back"></material-icon>' +
            "<span translate><ng-transclude></ng-transclude></span>" +
            "</a>",
    };
}

/* @ngInject */
export function simpleBackButton($window) {
    return {
        restrict: "E",
        transclude: true,
        template:
            '<span class="valign-wrapper cursor-pointer">' +
            '<material-icon name="arrow_back"></material-icon>' +
            "<span translate><ng-transclude></ng-transclude></span>" +
            "</span>",
        link: function (scope, element, attrs) {
            element.on("click", function () {
                $window.history.back();
            });
        },
    };
}

/* @ngInject */
export function resourceLink($window) {
    return {
        restrict: "A",
        scope: {
            url: "=",
        },
        link: function (scope, element, attrs) {
            element.on("click", function () {
                mixpanel.track("Resource link clicked", {
                    target_url: scope.url,
                });
                $window.open(scope.url, "_blank");
            });
        },
    };
}

/* @ngInject */
export function backImg() {
    return {
        restrict: "A",
        link: function (scope, element, attrs) {
            let publicID = attrs.backImg;
            if (publicID) {
                element.css({
                    "background-image":
                        "url(https://res.cloudinary.com/harvust/image/upload/" +
                        publicID +
                        ".jpg)",
                });
            } else {
                let src = attrs.backImgSrc;
                if (src) {
                    element.css({
                        "background-image": "url(" + src + ")",
                    });
                }
            }
        },
    };
}

/* @ngInject */
export function spinner() {
    return {
        restrict: "E",
        template: spinnerTemplate,
    };
}

/* @ngInject */
export function textInput() {
    return {
        restrict: "E",
        template: textInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputRequired: "=ngRequired",
            inputInputmode: "@",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
            inputType: "@",
        },
    };
}

/* @ngInject */
export function currencyInput() {
    return {
        restrict: "E",
        template: currencyInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputRequired: "=ngRequired",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
        },
        link: function (scope, elem, attrs, ngModelCtrl) {
            scope.viewAmount = "";

            function clean(val) {
                if (_.isNil(val)) return "";
                let s = String(val);
                s = s.replace(/[^0-9.]/g, "");
                let parts = s.split(".");
                if (parts.length > 2) {
                    s =
                        parts[0] +
                        "." +
                        parts.slice(1).join("").replace(/\./g, "");
                    parts = s.split(".");
                }
                if (parts[1]) parts[1] = parts[1].slice(0, 2);
                return parts.join(".");
            }

            function setValidity(str) {
                const valid = str === "" || /^[0-9]+(\.[0-9]{0,2})?$/.test(str);
                ngModelCtrl.$setValidity("currency", valid);
                return valid;
            }

            scope.onChange = function () {
                const cleaned = clean(scope.viewAmount);
                if (cleaned !== scope.viewAmount) {
                    scope.viewAmount = cleaned;
                }
                setValidity(cleaned);
                if (cleaned === "" || cleaned === ".") {
                    ngModelCtrl.$setViewValue(null);
                } else {
                    const num = parseFloat(cleaned);
                    ngModelCtrl.$setViewValue(isNaN(num) ? null : num);
                }
            };

            ngModelCtrl.$render = function () {
                const mv = ngModelCtrl.$viewValue;
                if (_.isNil(mv) || mv === "") {
                    scope.viewAmount = "";
                    return;
                }
                const num = typeof mv === "number" ? mv : parseFloat(mv);
                scope.viewAmount = isNaN(num) ? "" : num.toFixed(2);
            };

            const inputEl = elem.find("input");
            inputEl.on("blur", function () {
                scope.$applyAsync(function () {
                    const cleaned = clean(scope.viewAmount);
                    if (
                        setValidity(cleaned) &&
                        cleaned !== "" &&
                        cleaned !== "."
                    ) {
                        const num = parseFloat(cleaned);
                        if (!isNaN(num)) {
                            scope.viewAmount = num.toFixed(2);
                            ngModelCtrl.$setViewValue(num);
                        }
                    }
                });
            });

            scope.$on("$destroy", function () {
                inputEl.off("blur");
            });
        },
    };
}

/* @ngInject */
export function otpInput() {
    return {
        restrict: "E",
        template: otpInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputRequired: "=ngRequired",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
        },
    };
}

/* @ngInject */
export function passwordInput() {
    return {
        restrict: "E",
        template: passwordInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
        },
    };
}

/* @ngInject */
export function textareaInput() {
    return {
        restrict: "E",
        template: textAreaTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputRequired: "=ngRequired",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
            maxLength: "=",
        },
    };
}

/* @ngInject */
export function radioInput() {
    return {
        restrict: "E",
        template: radioInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputName: "@",
            inputLabel: "@",
            inputValue: "=ngValue",
            inputChange: "=ngChange",
            inputClick: "=ngClick",
        },
    };
}

/* @ngInject */
export function cardHeader() {
    return {
        restrict: "E",
        template: cardHeaderTemplate,
        scope: {
            headline: "@",
            prompt: "@",
        },
    };
}

/* @ngInject */
export function actionCard() {
    return {
        restrict: "E",
        transclude: true,
        template: actionCardTemplate,
        scope: {
            headline: "@",
            prompt: "@",
            cardClass: "@",
        },
    };
}

export function fileInput() {
    return {
        require: "ngModel",
        link: function postLink(scope, elem, attrs, ngModel) {
            elem.on("change", function (e) {
                let file = elem[0].files[0];
                ngModel.$setViewValue(file);
            });
        },
    };
}

export function phoneNumberInput() {
    return {
        scope: {
            inputDisabled: "=ngDisabled",
            inputRequired: "=ngRequired",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
        },
        require: "ngModel",
        template: phoneNumberInputTemplate,
        link: function (scope, elem, attrs, ngModelCtrl) {
            // Array of allowed country codes
            scope.allowedCodes = [
                { value: "+1", label: "US" },
                { value: "+52", label: "MX" },
                { value: "+56", label: "CL" },
            ];

            scope.updateModel = function () {
                let rawPhoneNumber = scope.phoneNumber || "";
                let codeDetected = false;

                // Only try to detect country codes if the number starts with "+"
                // or if the country dropdown hasn't been interacted with yet
                if (rawPhoneNumber.startsWith("+")) {
                    // If the number explicitly starts with +, handle as international format
                    scope.allowedCodes.forEach((code) => {
                        if (rawPhoneNumber.indexOf(code.value) === 0) {
                            // If found, update the dropdown selection
                            scope.countryCode = code.value;
                            // Remove the country code from the national phone number
                            rawPhoneNumber = rawPhoneNumber.substring(
                                code.value.length,
                            );
                            scope.phoneNumber = rawPhoneNumber;
                            codeDetected = true;
                        }
                    });
                }
                // For US numbers without +1 prefix (most common case), don't try to detect country codes
                // Let the user-selected country code apply

                let finalPhoneNumber =
                    rawPhoneNumber.length === 0
                        ? null
                        : scope.countryCode + rawPhoneNumber;
                ngModelCtrl.$setViewValue(finalPhoneNumber);
            };

            ngModelCtrl.$render = function () {
                let phoneNumber = phone(ngModelCtrl.$viewValue);
                if (phoneNumber.isValid) {
                    scope.countryCode = phoneNumber.countryCode;
                    scope.phoneNumber = phoneNumber.phoneNumber.substring(
                        phoneNumber.countryCode.length,
                    );
                } else {
                    let countryCode =
                        phoneNumber.countryCode === null ? "+1" : "";
                    scope.countryCode = countryCode;
                    scope.phoneNumber = "";
                }
            };
        },
    };
}

export function isoDate() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attrs, ngModelCtrl) {
            // View → Model
            ngModelCtrl.$parsers.push(function (viewValue) {
                if (!viewValue) {
                    ngModelCtrl.$setValidity("date", true);
                    return null;
                }
                const m = moment(viewValue, COMMON_DATE_FORMAT, true);
                if (!m.isValid()) {
                    ngModelCtrl.$setValidity("date", false);
                    return undefined;
                }
                ngModelCtrl.$setValidity("date", true);
                return m.format(DATE_FORMAT);
            });

            // Model → View
            ngModelCtrl.$formatters.push(function (modelValue) {
                if (!modelValue) {
                    return "";
                }
                const m = moment(modelValue);
                return m.isValid() ? m.format(COMMON_DATE_FORMAT) : "";
            });

            // helper to strip non‐digits and inject slashes
            function autoSlash(val) {
                let digits = val.replace(/\D/g, "").substr(0, 8);
                const m = digits.substr(0, 2);
                const d = digits.substr(2, 2);
                const y = digits.substr(4, 4);
                let out = m;
                if (d) out += "/" + d;
                if (y) out += "/" + y;
                return out;
            }

            // How to update the input when $viewValue changes
            ngModelCtrl.$render = function () {
                element.val(ngModelCtrl.$viewValue || "");
            };

            // On each keystroke, auto‐slash and push into ngModel
            element.on("input", function () {
                const raw = element.val();
                const formatted = autoSlash(raw);
                // update input box if formatting changed
                if (formatted !== raw) {
                    element.val(formatted);
                }
                scope.$applyAsync(function () {
                    ngModelCtrl.$setViewValue(formatted);
                });
            });

            // Also re‐format on blur (to catch any leftovers)
            element.on("blur", function () {
                const formatted = autoSlash(element.val());
                element.val(formatted);
                scope.$applyAsync(function () {
                    ngModelCtrl.$setViewValue(formatted);
                });
            });
        },
    };
}

/* @ngInject */
export function newDateInput() {
    return {
        restrict: "E",
        template: newDateInputTemplate,
        require: "ngModel",
        scope: {
            inputModel: "=ngModel",
            inputDisabled: "=ngDisabled",
            inputRequired: "=ngRequired",
            inputInputmode: "@",
            inputName: "@",
            inputLabel: "@",
            inputErrors: "=",
            inputType: "@",
        },
    };
}

export function formTripleAction() {
    return {
        restrict: "E",
        transclude: false,
        template: formTripleActionTemplate,
        scope: {
            nonFieldErrors: "=",
            submitLabel: "@",
            cancelLabel: "@",
            hideCancel: "=",
            deleteLabel: "@",
            deleteFunc: "&",
            showSpinner: "=",
        },
    };
}

export function uiLink() {
    return {
        restrict: "E",
        transclude: false,
        template: uiLinkTemplate,
        scope: {
            state: "@",
            params: "<",
            label: "@",
            target: "@",
            content: "@",
        },
    };
}

/* @ngInject */
export function anchorButton($state) {
    return {
        restrict: "E",
        transclude: false,
        template: anchorButtonTemplate,
        scope: {
            icon: "@",
            iconColor: "@",
            textColor: "@",
            color: "<",
            label: "@",
            state: "@",
            stateObj: "<",
            params: "<",
            direction: "@",
            classes: "@",
        },
        link: function (scope, element, attrs) {
            element.on("click", function () {
                scope.showSpinner = true;
                $state
                    .go(scope.state || scope.stateObj, scope.params)
                    .finally(function () {
                        scope.showSpinner = false;
                    });
            });

            // Clean up the event listener when the scope is destroyed.
            scope.$on("$destroy", function () {
                element.off("click");
            });
        },
    };
}

/* @ngInject */
export function cfVideo($sce) {
    return {
        restrict: "AE",
        scope: {
            srcId: "@srcId",
        },
        link: function (scope, elem, attr) {
            scope.srcUrl = $sce.trustAsResourceUrl(
                "https://customer-jxr2nkggvva4329o.cloudflarestream.com/" +
                    scope.srcId +
                    "/iframe",
            );
        },
        template: cfVideoTemplate,
    };
}

/* @ngInject */
export function lessonAudio() {
    return {
        restrict: "AE",
        scope: {
            playingCallback: "=",
            pauseCallback: "=",
            endedCallback: "=",
            src: "=src",
        },
        link: function (scope, elem, attr) {
            let audio = elem.find("audio");
            let callbacks = {
                play: scope.playingCallback,
                pause: scope.pauseCallback,
                ended: scope.endedCallback,
            };
            _.forEach(callbacks, function (func, event) {
                if (!_.isNil(func)) {
                    audio.on(event, func);
                }
            });
        },
        template:
            '<audio class="w-full" controls><source ng-src="{{ src }}"></audio>',
    };
}

/* @ngInject */
export function stateTitle($transitions, $translate) {
    return {
        link: function (scope, element, attrs) {
            let listener = function (event, toState) {
                let resolvedVariables = {};
                _.forEach(_.keys(toState.resolve), function (name) {
                    resolvedVariables[name] = event.injector().get(name);
                });
                let pattern = "%s | Harvust";
                let title = _.get(
                    toState.data,
                    "title",
                    "routes.UNTITLED_PAGE",
                );
                title = $translate.instant(title, resolvedVariables);
                title = pattern.replace(/%s/g, title);
                /* Set the title */
                element.text(title);
            };

            $transitions.onSuccess({}, function (trans) {
                listener(trans, trans.to());
            });
        },

        restrict: "A",

        scope: false,
    };
}

/* @ngInject */
export function stateMetaDescription($transitions, $translate) {
    return {
        link: function (scope, element, attrs) {
            let listener = function (event, toState) {
                let resolvedVariables = {};
                _.forEach(_.keys(toState.resolve), function (name) {
                    resolvedVariables[name] = event.injector().get(name);
                });
                let description = _.get(toState.data, "description");
                if (description) {
                    description = $translate.instant(
                        description,
                        resolvedVariables,
                    );
                    /* Set the title */
                    element.attr("content", description);
                }
            };

            $transitions.onSuccess({}, function (trans) {
                listener(trans, trans.to());
            });
        },
        restrict: "A",
        scope: false,
    };
}

/* @ngInject */
export function profilePicture() {
    return {
        restrict: "E",
        transclude: false,
        template: profilePictureTemplate,
        scope: {
            publicId: "=",
            size: "@",
            imgClass: "@",
        },
    };
}

/* @ngInject */
export function renderMarkdown() {
    return {
        restrict: "E",
        transclude: false,
        scope: {
            content: "=",
        },
        link: function (scope, elem, attr) {
            if (scope.content) {
                let renderedContent = marked(scope.content);
                elem.html(renderedContent);
            }
        },
    };
}

const icons = {
    search,
    photo_camera,
    library_books,
    call_made,
    cancel,
    schedule,
    warning,
    arrow_forward,
    update,
    check_circle,
    timelapse,
    thumb_up,
    close,
    done,
    home,
    help,
    settings,
    menu,
    arrow_drop_down,
    add,
    file_download,
    fiber_manual_record,
    place,
    highlight_off,
    print,
    autorenew,
    clear_all,
    attach_file,
    add_location,
    play_circle_outline,
    description,
    person,
    volume_up,
    arrow_back,
    delete: delete_icon,
    import_export,
    expand_more,
    expand_less,
    remove_circle_outline,
    class: class_icon,
    send,
    phone_enabled,
    phone_disabled,
    arrow_right_alt,
    link,
    open_in_browser,
    open_in_new,
    check,
    sort,
    filter_list,
    cancel_presentation,
    assignment,
    notifications_active,
    person_add,
    create,
    pan_tool,
    done_all,
    timer,
    call,
    directions,
    email,
    directions_car,
    health_and_safety,
    navigate_next,
    badge,
    upload,
    swap_horiz,
    bolt,
    preview,
    send_to_mobile,
    star,
    currency_exchange,
    archive,
    chat,
    mic,
    stop,
    report,
    account_balance,
    credit_card,
    history,
    whatshot,
};

/* @ngInject */
export function materialIcon() {
    return {
        restrict: "E",
        transclude: false,
        scope: {
            name: "@",
            classes: "@",
            width: "<",
            height: "<",
        },
        link: function (scope, elem, attr) {
            scope.src = icons[scope.name];
            let img = elem.find("img")[0];
            if (scope.width) {
                img.width = scope.width;
            } else {
                img.width = 24;
            }
            if (scope.height) {
                img.height = scope.height;
            } else {
                img.height = 24;
            }
        },
        template: '<img class="harvust-icon {{classes}}" ng-src="{{src}}">',
    };
}

/* @ngInject */
export function multiSelectDropdown($document, $templateCache) {
    return {
        restrict: "E",
        template: multiSelectDropdownTemplate,
        require: "ngModel",
        transclude: true,
        scope: {
            ngModel: "=",
            ngDisabled: "=",
            options: "=",
            keepOrder: "=",
            displayProperty: "@",
            valueProperty: "@",
            // If true, behaves like a single-select dropdown. ngModel is a single value/null instead of an array.
            singleSelect: "=",
        },
        link: function (scope, element, attrs, ngModelCtrl, transcludeFn) {
            console.log("MultiSelectDropdown: Initializing directive", {
                attrs: attrs,
                initialModel: scope.ngModel,
                options: scope.options,
                keepOrder: scope.keepOrder,
                displayProperty: scope.displayProperty,
                valueProperty: scope.valueProperty,
                singleSelect: scope.singleSelect,
            });

            // Initialize scope variables
            scope.isOpen = false;
            scope.selectedItems = [];

            // Capture any transcluded custom option template and register it
            scope._hasOptionTemplate = false;
            scope._optionTemplateUrl = null;
            if (typeof transcludeFn === "function") {
                try {
                    transcludeFn(function (clone) {
                        // Build a string from the transcluded nodes
                        var html = "";
                        angular.forEach(clone, function (node) {
                            if (!node) return;
                            if (node.nodeType === 1 && node.outerHTML) {
                                html += node.outerHTML;
                            } else if (
                                node.nodeType === 3 &&
                                node.textContent
                            ) {
                                // Text node
                                html += node.textContent;
                            }
                        });
                        if (html && html.trim().length) {
                            var tplId = "msd/optionTemplate/" + scope.$id;
                            $templateCache.put(tplId, html);
                            scope._optionTemplateUrl = tplId;
                            scope._hasOptionTemplate = true;
                        }
                    });
                } catch (e) {
                    // Fallback safely if transclusion fails
                    console.warn("MultiSelectDropdown: transclusion failed", e);
                }
            }

            // Configure display and value properties
            scope.displayProperty = scope.displayProperty || "name";
            // Watch for changes in ngModel
            scope.$watch("ngModel", function (newValue, oldValue) {
                console.log("MultiSelectDropdown: ngModel changed", {
                    oldValue: oldValue,
                    newValue: newValue,
                    isArray: angular.isArray(newValue),
                    singleSelect: scope.singleSelect,
                });
                if (scope.singleSelect) {
                    // Coerce array -> first value when mistakenly passed.
                    if (angular.isArray(newValue)) {
                        const coerced = newValue.length ? newValue[0] : null;
                        if (coerced !== newValue) {
                            scope.ngModel = coerced;
                            ngModelCtrl.$setViewValue(coerced);
                        }
                        newValue = coerced;
                    }
                    if (_.isNil(newValue) || newValue === "") {
                        scope.selectedItems = [];
                    } else {
                        // Wrap single value in array for reuse of updateSelectedItems
                        if (angular.isArray(scope.options)) {
                            updateSelectedItems([newValue]);
                        }
                    }
                } else {
                    if (angular.isArray(newValue)) {
                        updateSelectedItems(newValue);
                    } else {
                        scope.selectedItems = [];
                    }
                }
            });

            // Watch for changes in options
            scope.$watch("options", function (newOptions, oldOptions) {
                console.log("MultiSelectDropdown: options changed", {
                    oldOptions: oldOptions,
                    newOptions: newOptions,
                    isArray: angular.isArray(newOptions),
                    singleSelect: scope.singleSelect,
                });
                if (!angular.isArray(newOptions)) return;
                if (scope.singleSelect) {
                    if (!_.isNil(scope.ngModel) && scope.ngModel !== "") {
                        updateSelectedItems([scope.ngModel]);
                    }
                } else if (angular.isArray(scope.ngModel)) {
                    updateSelectedItems(scope.ngModel);
                }
            });

            // Helper function to get display text for an item
            scope.getDisplayText = function (item) {
                var displayText;
                if (typeof item === "string") {
                    displayText = item;
                } else {
                    displayText = _.get(item, scope.displayProperty);
                }
                return displayText;
            };

            // Helper function to get value for an item
            function getItemValue(item) {
                var value;
                if (typeof item === "string") {
                    value = item;
                } else {
                    value = _.get(item, scope.valueProperty, item);
                }
                return value;
            }

            // Update selected items based on model values
            function updateSelectedItems(modelValues) {
                scope.selectedItems = [];

                if (
                    !angular.isArray(modelValues) ||
                    !angular.isArray(scope.options)
                ) {
                    console.log(
                        "MultiSelectDropdown: Skipping update - invalid arrays",
                    );
                    return;
                }

                if (scope.keepOrder) {
                    // Preserve order from model
                    modelValues.forEach(function (modelValue) {
                        var foundOption = scope.options.find(function (option) {
                            return getItemValue(option) === modelValue;
                        });
                        if (foundOption) {
                            scope.selectedItems.push(foundOption);
                        }
                    });
                } else {
                    // Use order from options array
                    scope.options.forEach(function (option) {
                        if (modelValues.indexOf(getItemValue(option)) !== -1) {
                            scope.selectedItems.push(option);
                        }
                    });
                }
            }

            // Toggle dropdown open/closed
            scope.toggleDropdown = function () {
                if (scope.ngDisabled) return;
                scope.isOpen = !scope.isOpen;
            };

            // Check if an option is selected
            scope.isSelected = function (option) {
                if (scope.singleSelect) {
                    return getItemValue(option) === scope.ngModel;
                }
                if (!angular.isArray(scope.ngModel)) {
                    return false;
                }
                return scope.ngModel.indexOf(getItemValue(option)) !== -1;
            };

            // Toggle selection of an option
            scope.toggleOption = function (option) {
                if (scope.ngDisabled) return;

                var optionValue = getItemValue(option);

                if (scope.singleSelect) {
                    const newVal =
                        optionValue === scope.ngModel ? null : optionValue;
                    console.log(
                        "MultiSelectDropdown: Updating single-select model",
                        {
                            oldModel: scope.ngModel,
                            newModel: newVal,
                        },
                    );
                    scope.ngModel = newVal;
                    ngModelCtrl.$setViewValue(newVal);
                    // Close the dropdown after choosing in single select mode
                    scope.isOpen = false;
                    return;
                }

                var modelArray = angular.isArray(scope.ngModel)
                    ? scope.ngModel.slice()
                    : [];
                var index = modelArray.indexOf(optionValue);

                if (index === -1) {
                    if (scope.keepOrder) {
                        modelArray.push(optionValue);
                    } else {
                        var insertIndex = 0;
                        for (var i = 0; i < scope.options.length; i++) {
                            var currentOptionValue = getItemValue(
                                scope.options[i],
                            );
                            if (currentOptionValue === optionValue) break;
                            if (modelArray.indexOf(currentOptionValue) !== -1)
                                insertIndex++;
                        }
                        modelArray.splice(insertIndex, 0, optionValue);
                    }
                } else {
                    modelArray.splice(index, 1);
                }

                console.log("MultiSelectDropdown: Updating model", {
                    oldModel: scope.ngModel,
                    newModel: modelArray,
                });
                scope.ngModel = modelArray;
                ngModelCtrl.$setViewValue(modelArray);
            };

            // Remove specific item
            scope.removeItem = function (item, event) {
                if (event) {
                    event.stopPropagation();
                }
                if (scope.ngDisabled) return;

                if (scope.singleSelect) {
                    console.log(
                        "MultiSelectDropdown: Clearing single-select selection",
                        { oldModel: scope.ngModel },
                    );
                    scope.ngModel = null;
                    ngModelCtrl.$setViewValue(null);
                    scope.selectedItems = [];
                    return;
                }

                var itemValue = getItemValue(item);
                var modelArray = angular.isArray(scope.ngModel)
                    ? scope.ngModel.slice()
                    : [];
                var index = modelArray.indexOf(itemValue);
                if (index !== -1) {
                    modelArray.splice(index, 1);
                    scope.ngModel = modelArray;
                    ngModelCtrl.$setViewValue(modelArray);
                }
            };

            // Close dropdown when clicking outside
            var documentClickHandler = function (event) {
                if (scope.isOpen && !element[0].contains(event.target)) {
                    scope.$apply(function () {
                        scope.isOpen = false;
                    });
                }
            };

            $document.on("click", documentClickHandler);

            // Cleanup on destroy
            scope.$on("$destroy", function () {
                $document.off("click", documentClickHandler);
            });
        },
    };
}

/* @ngInject */
export function languageAttribute($rootScope) {
    return {
        link: function (scope, element) {
            $rootScope.$on(
                "$translateChangeSuccess",
                function (event, translationResp) {
                    element.attr("lang", translationResp.language || ENGLISH);
                },
            );
        },
    };
}

/* @ngInject */
export function stateProgressBar($state) {
    return {
        restrict: "E",
        scope: {
            states: "<",
        },
        template: stateProgressBarTemplate,
        link: function (scope, element, attrs) {
            scope.isAfter = function (state) {
                let currentStateIndex = scope.states.findIndex($state.includes);
                let thisStateIndex = scope.states.findIndex(function (element) {
                    return element === state;
                });
                return thisStateIndex > currentStateIndex;
            };
        },
    };
}
